module.exports = __webpack_public_path__ + "static/img/p02.f3d5ea8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/comic/001/p02.jpg
// module id = 115
// module chunks = 0